module.exports = __webpack_public_path__ + "static/media/present-img.e959a31a.svg";